"use client";

import { ArcadeEmbed } from "@/components/common/ArcadeEmbed";

const WELCOME_TUTORIAL_URL =
  "https://demo.arcade.software/Ja9PImmQd2H2jOzHNxqd?embed&embed_mobile=tab&embed_desktop=inline&squared=true&show_copy_link=true";

interface WelcomeTutorialProps {
  onClose: () => void;
  buttonText?: string;
  onFinalStep?: () => void;
}

export function WelcomeTutorial({
  onClose,
  buttonText = "Close",
  onFinalStep,
}: WelcomeTutorialProps) {
  return (
    <ArcadeEmbed
      url={WELCOME_TUTORIAL_URL}
      title="Welcome tutorial"
      onClose={onClose}
      buttonText={buttonText}
      onFinalStep={onFinalStep}
    />
  );
}
